import AgileControlsResources = require("Agile/Scripts/Resources/TFS.Resources.AgileControls");
import Configurations = require("Presentation/Scripts/TFS/TFS.Configurations");
import BoardsSettingsControls = require("Agile/Scripts/Board/BoardsSettingsControls");
import CardStyleCustomization_NO_REQUIRE = require("Agile/Scripts/Card/CardCustomizationStyle");

import TeamServices = require("TfsCommon/Scripts/Team/Services");
import { registerCardSettings } from "Agile/Scripts/Settings/CardSettingsConfiguration";
import { registerGeneralSettings } from "Agile/Scripts/Settings/GeneralSettingsConfiguration";
import { TabControlsRegistrationConstants } from "Agile/Scripts/Common/Agile";

export {
  registerCardSettings
} from "Agile/Scripts/Settings/CardSettingsConfiguration";
export {
  registerGeneralSettings
} from "Agile/Scripts/Settings/GeneralSettingsConfiguration";

export {
  registerTaskboardSettingsForIterationLevel
} from "Agile/Scripts/Settings/TaskboardCommonSettingsConfiguration";


export namespace CommonSettingsConfigurationUtils {
  export function registerBacklogSettingsForBacklogLevel(
    teamId: string,
    boardSettingsOptions: BoardsSettingsControls.IBoardSettingTabOptions,
    currentUserTeamPermissions: TeamServices.ITeamPermissions
  ) {
    registerGeneralSettings(
      teamId,
      currentUserTeamPermissions,
      /* showBacklogVisibilitiesTab */ true
    );
  }

  export function registerKanbanSettingsForBacklogLevel(
    teamId: string,
    boardSettingsOptions: BoardsSettingsControls.IBoardSettingTabOptions,
    currentUserTeamPermissions: TeamServices.ITeamPermissions,
    fieldOptions?: BoardsSettingsControls.IFieldSettingsControlOptions,
    styleOptions?: CardStyleCustomization_NO_REQUIRE.ICardStyleSettingsCSCControlInitOptions,
    tagOptions?: CardStyleCustomization_NO_REQUIRE.ICardStyleSettingsCSCControlInitOptions,
    annotationOptions?: CardStyleCustomization_NO_REQUIRE.ICardStyleSettingsCSCControlInitOptions
  ) {
    registerCardSettings(
      fieldOptions,
      styleOptions,
      tagOptions,
      annotationOptions
    );
    registerBoardSettings(boardSettingsOptions);
    registerGeneralSettings(
      teamId,
      currentUserTeamPermissions,
      /* showBacklogVisibilitiesTab */ true
    );
  }

  export function registerKanbanSettingsForEmbeddedBacklogLevel(
    boardSettingsOptions: BoardsSettingsControls.IBoardSettingTabOptions,
    fieldOptions: BoardsSettingsControls.IFieldSettingsControlOptions,
    styleOptions: CardStyleCustomization_NO_REQUIRE.ICardStyleSettingsCSCControlInitOptions,
    tagOptions: CardStyleCustomization_NO_REQUIRE.ICardStyleSettingsCSCControlInitOptions,
    annotationOptions?: CardStyleCustomization_NO_REQUIRE.ICardStyleSettingsCSCControlInitOptions
  ) {
    registerCardSettings(
      fieldOptions,
      styleOptions,
      tagOptions,
      annotationOptions
    );
    registerBoardSettings(boardSettingsOptions);
  }

  export function registerGeneralSettingsForIterationLevel(
    teamId: string,
    currentUserTeamPermissions: TeamServices.ITeamPermissions,
    showBacklogVisibilitiesTab: boolean
  ) {
    registerGeneralSettings(
      teamId,
      currentUserTeamPermissions,
      showBacklogVisibilitiesTab
    );
  }

  function registerBoardSettings(
    tabContentOptions: BoardsSettingsControls.IBoardSettingTabOptions
  ) {
    if (tabContentOptions) {
      Configurations.TabControlsRegistration.registerTabGroup({
        tabControlId:
          TabControlsRegistrationConstants.COMMON_CONFIG_SETTING_INSTANCE_ID,
        id: TabControlsRegistrationConstants.BOARDS_GROUP_ID,
        title: TabControlsRegistrationConstants.BOARD_GROUP_TITLE,
        order: 20
      });

      registerSwimlaneSettingsTab(tabContentOptions);
      registerColumnSettingsTab(tabContentOptions);
      registerCardReorderingTab(tabContentOptions);
      registerBoardBadgeTab(tabContentOptions);
    }
  }

  function registerColumnSettingsTab(
    tabContentOptions: BoardsSettingsControls.IBoardSettingTabOptions
  ) {
    Configurations.TabControlsRegistration.registerTab({
      groupId: TabControlsRegistrationConstants.BOARDS_GROUP_ID,
      id: TabControlsRegistrationConstants.COLUMNS_TAB_ID,
      title: AgileControlsResources.Board_Settings_Columns,
      tabContent: BoardsSettingsControls.ColumnSettingsControl,
      tabContentOptions: <BoardsSettingsControls.IColumnSettingsControlOptions>(
        tabContentOptions
      ),
      dependentOn: [TabControlsRegistrationConstants.SWIMLANES_TAB_ID],
      order: 10
    });
  }

  function registerSwimlaneSettingsTab(
    tabContentOptions: BoardsSettingsControls.IBoardSettingTabOptions
  ) {
    Configurations.TabControlsRegistration.registerTab({
      groupId: TabControlsRegistrationConstants.BOARDS_GROUP_ID,
      id: TabControlsRegistrationConstants.SWIMLANES_TAB_ID,
      title: AgileControlsResources.Board_Settings_Swimlanes,
      tabContent: BoardsSettingsControls.SwimlaneSettingsControl,
      tabContentOptions: <
        BoardsSettingsControls.ISwimlaneSettingsControlOptions
        >tabContentOptions,
      order: 20
    });
  }

  function registerCardReorderingTab(tabContentOptions: any) {
    if (
      tabContentOptions.boardSettings &&
      typeof tabContentOptions.boardSettings.cardReorderingFeatureEnabled ===
      "boolean" &&
      tabContentOptions.boardSettings.cardReorderingFeatureEnabled
    ) {
      Configurations.TabControlsRegistration.registerTab({
        groupId: TabControlsRegistrationConstants.BOARDS_GROUP_ID,
        id: TabControlsRegistrationConstants.KANBAN_DRAG_BEHAVIOR_ID,
        title: AgileControlsResources.Board_Settings_Card_Reordering,
        tabContent: BoardsSettingsControls.CardReorderingTabContent,
        tabContentOptions: tabContentOptions,
        order: 30
      });
    }
  }

  function registerBoardBadgeTab(tabContentOptions: any) {
    if (
      tabContentOptions.boardSettings  
    ) {
      Configurations.TabControlsRegistration.registerTab({
        groupId: TabControlsRegistrationConstants.BOARDS_GROUP_ID,
        id: TabControlsRegistrationConstants.BOARD_BADGE_TAB_ID,
        title: AgileControlsResources.Board_Options_Badge_Title,
        tabContent: BoardsSettingsControls.BoardBadgeTabContent,
        tabContentOptions: tabContentOptions,
        order: 40
      });
    }
  }
  
}
